var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-layout"},[_c('div',{staticClass:"aside-container"},[_vm._t("aside")],2),_c('el-divider',{attrs:{"direction":"vertical"}}),_c('div',{staticClass:"main-container"},[_vm._t("default",function(){return [_c('router-view')]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }